import Swiper, { Navigation } from 'swiper';

class ImageCarousel {
  constructor(el) {
    this.el = el;
  }

  init() {
    const slider = new Swiper(this.el, {
      modules: [Navigation],
      slidesPerView: 1,
      loop: true,
      allowTouchMove: true,
      centeredSlides: false,
      spaceBetween: 12,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: {
          slidesPerView: 3,
        },
      },
    });

    this.slider = slider;
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const imageCarousels = document.querySelectorAll('.image-carousel .container .swiper');

  imageCarousels.forEach((el) => {
    new ImageCarousel(el).init();
  });
});
